import { selectActiveProjectName, useAppSelector } from '@core/core/store'
import type { ObjectTreeNode, SubMenuUploadFileType } from '@core/core/types'
import { getDataToSendEvent } from '@core/core/utils'
import { useSpa } from '@core/hooks'
import type { Nullable } from 'common/types'
import { useState } from 'react'

import { useOpenFilePicker } from './useOpenFilePicker'

export const useUploadFiles = () => {
  const sendSpaEvent = useSpa()
  const [uploadFiles, , getFilesFromExplorer] = useOpenFilePicker()
  const [uploadMode, setUploadMode] = useState<Nullable<SubMenuUploadFileType>>(null)
  const [objectTreeNodeModal, setObjectTreeNodeModal] = useState<Nullable<ObjectTreeNode>>(null)
  const activeProjectName = useAppSelector(selectActiveProjectName)

  const handleUploadFiles = (type?: SubMenuUploadFileType, objectTreeNode?: ObjectTreeNode) => {
    const data = getDataToSendEvent(activeProjectName, type)
    if (data) sendSpaEvent(data.id, data.params)

    getFilesFromExplorer(type).then(() => {
      setObjectTreeNodeModal(objectTreeNode ?? null)
      setUploadMode(type ?? null)
    })
  }

  return {
    objectTreeNodeModal,
    uploadMode,
    uploadFiles,
    handleUploadFiles,
  }
}
